import { render, staticRenderFns } from "./ed-simple-chip.vue?vue&type=template&id=93eb2032&scoped=true&"
import script from "./ed-simple-chip.ts?vue&type=script&lang=js&"
export * from "./ed-simple-chip.ts?vue&type=script&lang=js&"
import style0 from "./ed-simple-chip.scss?vue&type=style&index=0&id=93eb2032&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93eb2032",
  null
  
)

export default component.exports